"use client";

import { Breadcrumb, BreadcrumbItem } from "@carbon/react";
import NextLink from "next/link";

export type PageCrumb = {
  label: string;
  href?: string;
};

type PageHeaderProps = {
  title: string;
  description?: string;
  crumbs?: readonly PageCrumb[];
};

export function PageHeader({ title, description, crumbs }: PageHeaderProps) {
  return (
    <header className="page-header">
      <div className="page-header-copy">
        {crumbs && crumbs.length > 0 ? (
          <Breadcrumb noTrailingSlash size="sm" aria-label="Навигация">
            {crumbs.map((crumb, index) => {
              const current = !crumb.href || index === crumbs.length - 1;
              return (
                <BreadcrumbItem
                  key={`${crumb.label}-${index}`}
                  isCurrentPage={current && !crumb.href}
                >
                  {crumb.href ? (
                    <NextLink href={crumb.href}>{crumb.label}</NextLink>
                  ) : (
                    crumb.label
                  )}
                </BreadcrumbItem>
              );
            })}
          </Breadcrumb>
        ) : null}
        <h1>{title}</h1>
        {description ? <p>{description}</p> : null}
      </div>
    </header>
  );
}
